import { Fragment } from 'react';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';
import { helpScoutContactForm } from 'src/utils/helpScoutBeacon';

const ErrorBanner = () => (
  <Fragment>
    {i18n.t('Something went wrong, please  ')}
    <LinkButton onClick={helpScoutContactForm}>
      {i18n.t('contact the HealthUnlocked team.')}
    </LinkButton>
  </Fragment>
);

export default ErrorBanner;
